import {
  IGetAllRouteByTeamSaleInPlant,
  IGetAllTeamSaleByPlant,
} from 'interfaces/TeamSale/TeamSale';
import axiosGraphQL from './GraphQL/axiosGraphQL';
import * as SaleLineTeam from './GraphQL/Queries/saleLineTeamQuery';
import { SaleLineTeam_VARIABLE } from './GraphQL/Variables/saleLineTeam';

export interface ICreateSaleTeamRoute {
  teamSalesId: string;
  routeId: string;
}

export interface IUpdateSaleTeamRoute {
  id?: string;
  teamSalesId?: string;
  routeId?: string;
  useYn?: boolean;
}

export type ICheckExistSaleTeamRoute = ICreateSaleTeamRoute & {
  useYn?: boolean;
};

const SaleLineTeamApis = {
  getSaleLineTeamApis: async (params: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: SaleLineTeam.GET_ALL_SALE_TEAM_ROUTE_TRIP,
      variables: SaleLineTeam_VARIABLE.getListSaleLineTeam(params),
    });
  },
  updateSaleLineTeam: async (data: IUpdateSaleTeamRoute) => {
    return await axiosGraphQL.post('/graphql', {
      query: SaleLineTeam.Update_team_sales_route,
      variables: SaleLineTeam_VARIABLE.updateSalelineTeam(data),
    });
  },
  checkExistSaleTeamInRoute: async (routeId: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: SaleLineTeam.CHECK_EXIST_SALE_TEAM_IN_ROUTE,
      variables: SaleLineTeam_VARIABLE.checkExistSaleTeamInRoute(routeId),
    });
  },
  createSaleTeamRoute: async (params: ICreateSaleTeamRoute) => {
    return await axiosGraphQL.post('/graphql', {
      query: SaleLineTeam.CREATE_SALE_TEAM_ROUTE,
      variables: SaleLineTeam_VARIABLE.createSaleTeamRoute(params),
    });
  },
  checkExistSaleTeamRoute: async (params: ICheckExistSaleTeamRoute) => {
    return await axiosGraphQL.post('/graphql', {
      query: SaleLineTeam.CHECK_EXIST_SALE_TEAM_ROUTE,
      variables: SaleLineTeam_VARIABLE.checkExistSaleTeamRoute(params),
    });
  },
  updateManySalesTeamRoute: async (data: IUpdateSaleTeamRoute[]) => {
    return await axiosGraphQL.post('/graphql', {
      query: SaleLineTeam.UPDATE_MANY_SALES_TEAM_ROUTE,
      variables: SaleLineTeam_VARIABLE.updateManySalelineTeam(data),
    });
  },
  getAllTeamSaleByPlant: async (params: IGetAllTeamSaleByPlant) => {
    return axiosGraphQL.post('/graphql', {
      query: SaleLineTeam.GET_ALL_TEAM_SALE_BY_PLANT,
      variables: SaleLineTeam_VARIABLE.getAllTeamSaleByPlant(params),
    });
  },
  getAllRouteByTeamSaleInPlant: async (
    params: IGetAllRouteByTeamSaleInPlant,
  ) => {
    return axiosGraphQL.post('/graphql', {
      query: SaleLineTeam.GET_ALL_ROUTE_BY_TEAM_SALE_IN_PLANT,
      variables: SaleLineTeam_VARIABLE.getAllRouteByTeamSaleInPlant(params),
    });
  },
};

export default SaleLineTeamApis;
